import Navbar from "@/components/Navbar";
import Consulting from "@/components/Consulting";
import Manifesto from "@/components/Manifesto";
import Expertise from "@/components/Expertise";
import Clients from "@/components/Clients";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import BookingModal from "@/components/BookingModal";
import { useLenis, useHashScroll } from "@/hooks/usePageUtils";

const ConsultingPage = () => {
  useLenis();
  useHashScroll();

  return (
    <>
      <Navbar />
      <main className="pt-24">
        <Consulting />
        <Manifesto />
        <Expertise />
        <Clients />
        <Contact />
      </main>
      <Footer />
      <BookingModal />
    </>
  );
};

export default ConsultingPage;
